import { Subscription, SubscriptionStates } from 'services/api';

import { formatDate } from './format-date';

export const mapSubscriptionDurationToMonth = (numOfMonths: number): string => {
  if (numOfMonths === 12) {
    return 'Yearly';
  } else if (numOfMonths === 6) {
    return 'Half-yearly';
  } else {
    return 'Monthly';
  }
};

export const formatUserSubscriptionDetails = (
  subscription: Subscription,
  currencyCode: string
): string => {
  const duration = mapSubscriptionDurationToMonth(subscription.duration);
  const amount = subscription.amount;
  const nextBillingDate =
    subscription.state !== SubscriptionStates.cancelled &&
    formatDate(subscription.next_billing_date);

  //todo map currency country code to currency

  return `${duration} - ${currencyCode} ${amount}${
    nextBillingDate ? ` · Next renewal on ${nextBillingDate}` : ''
  }`;
};
